import {Routes} from '@angular/router';
import {
  goodsDetailImgManagementRoutes
} from "./goods-detail-img-management/goods-detail-img-management.routes";
import {
  goodsDetailPropertyManagementRoutes
} from "./goods-detail-property-management/goods-detail-property-management.routes";

export const goodsManagementRoutes: Routes = [
  {
    path: 'goodsManagement',
    loadComponent: () => import('./goods-management/goods-management.component').then(m => m.GoodsManagementComponent),
    data: {title: '商品管理'},
  },
  {
    path: 'brandManagement',
    loadComponent: () => import('./brand-management/brand-management.component').then(m => m.BrandManagementComponent),
    data: {title: '品牌管理'},
  },
  {
    path: 'categoryManagement',
    loadComponent: () => import('./category-management/category-management.component').then(m => m.CategoryManagementComponent),
    data: {title: '品类管理'},
  },
  {
    path: 'addGoods',
    loadComponent: () => import('./goods-management/add-goods/add-goods.component').then(m => m.AddGoodsComponent),
    data: {title: '添加商品'},
  },
  {
    path: 'addGoods/:goodsId',
    loadComponent: () => import('./goods-management/add-goods/add-goods.component').then(m => m.AddGoodsComponent),
    data: {title: '编辑商品'},
  },
  {
    path: 'unitManagement',
    loadComponent: () => import('./unit-management/unit-management.component').then(m => m.UnitManagementComponent),
    data: {title: '计量单位管理'},
  },
  {
    path: 'skuManagement',
    loadComponent: () => import('./sku-management/sku-management.component').then(m => m.SkuManagementComponent),
    data: {title: 'sku管理'},
  },
  {
    path: 'addSku',
    loadComponent: () => import('./sku-management/add-sku/add-sku.component').then(m => m.AddSkuComponent),
    data: {title: '添加sku'},
  },
  {
    path: 'addSku/:goodsId',
    loadComponent: () => import('./sku-management/add-sku/add-sku.component').then(m => m.AddSkuComponent),
    data: {title: '编辑sku'},
  },
  {
    path: 'categoryManagement',
    loadComponent: () => import('./category-management/category-management.component').then(m => m.CategoryManagementComponent),
    data: {title: '品类管理'},
  },
  {
    path: 'imagesStoreManagement',
    loadComponent: () => import('./images-store-management/images-store-management.component').then(m => m.ImagesStoreManagementComponent),
    data: {title: '图片管理'},
  },
  {
    path: 'goodsImagesManagement',
    loadComponent: () => import('./goods-images-management/goods-images-management.component').then(m => m.GoodsImagesManagementComponent),
    data: {title: '识别商品图库管理'},
  },
  {
    path: 'goodsCodeManagement',
    loadComponent: () => import('./goodscode-management/goodscode-management.component').then(m => m.GoodscodeManagementComponent),
    data: {title: '商品编码管理'},
  },
  ...goodsDetailImgManagementRoutes,
  ...goodsDetailPropertyManagementRoutes,
];
